// src/mocks/lib/authTokenUtils.ts

import {
  accessTokenExpiry,
  refreshTokenExpiry,
} from '@/mocks/data/tokenTimers';

export function isAccessTokenExpired(): boolean {
  return Date.now() > accessTokenExpiry;
}

export function isRefreshTokenExpired(): boolean {
  return Date.now() > refreshTokenExpiry;
}
